<template>
  <div class="navbar">
    <nav class="nav-extended white">
      <div class="nav-content">
        <router-link :to="{ name: 'Index' }">
          <span class="nav-title blue-grey-text text-darken-4">Recipe Manager</span>
        </router-link>
        <a href="" class="btn-floating btn-large halfway-fab blue-grey">
          <router-link :to="{ name: 'AddRecipe' }">
            <i class="material-icons">add</i>
          </router-link>
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {

    }
  }
}
</script>

<style lang="">
@import url('https://fonts.googleapis.com/css?family=Kalam');

.navbar {
  width: 100%;
  user-select: none;
}
.navbar nav {
  padding: 0 20px;
}
.navbar .nav-logo {
  display: inline-block;
  font-size: 1.5em;
  padding-right: 1vw;
}
.navbar .nav-title {
  left: 5vw;
  font-size: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue